//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import { BImg } from 'bootstrap-vue'


export default {

    name: 'ProfileCaseStudyPopup',

    mixins: [ProfileData],

    components: { BImg },

    props: {
        company: {
        },
        caseStudy: {
        }
    },

    data() {
        return {
        }
    },


    methods: {

        openGallery(index) {
            this.$bus.$emit('openCompanyGallery', this.caseStudy.images, index)
        }

    },

    computed: {

        imagesPreview() {
            return this.caseStudy.images.slice(0, 3)
        },

        durationUnit() {

            if(this.caseStudy.duration > 1) {
                return 'days'
            }

            return 'day'

        },

    },


}

